var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selection-card__oos",class:{ 'cz2__non-interactive': _vm.isDisabled }},[_c('p',{staticClass:"selection-card__oos-copy"},[_vm._v(" "+_vm._s(_vm.$t('OOS_WARNING_TITLE'))+" ")]),_c('img',{staticClass:"selection-card__oos-icon",attrs:{"src":require("../../assets/icons/alert.svg"),"alt":"","aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }